import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/UserContext';
import { Helmet } from 'react-helmet';
import utils from '../../utils';
import DashSidebar from '../../components/dashboard/DashSidebar';
import toast from 'react-hot-toast';
import DashOverView from '../../components/vendor/DashOverView';
import ProductsTab from '../../components/dashboard/ProductsTab';
import OrdersTab from '../../components/dashboard/OrdersTab';
import RefundsTab from '../../components/orders/RefundsTabs';

function VendorDashBoard() {
    const { user, store } = useAuth()
    const [tab, setTab] = useState(0)
    const navigate = useNavigate();

    function changeTab(val) {
        if (!user?.is_verified) {
            toast.error("You have to be Verified By Admin First!")
            return
        }
        if (!store) {
            toast.error("Please Create Your Store First")
            return
        }
        setTab(val)
        window.scrollTo(0, 0);
        const url = new URL(window.location);
        url.search = ''
        navigate(url.pathname, { replace: true });
    }
    return (
        <div>
            <div className='px-6 py-4 container mx-auto'>
                <Helmet>
                    <title>Vendor Dashboard - {utils.siteName}</title>
                </Helmet>
                <div className="flex flex-col md:flex-row gap-8 lg:gap-12">
                    <DashSidebar
                        tab={tab}
                        changeTab={changeTab} />
                    <div className="flex-1">
                        {tab === 0 && (
                            <DashOverView />
                        )}
                        {tab === 3 && (
                            <ProductsTab />
                        )}
                        {tab === 2 && (
                            <OrdersTab />
                        )}
                        {tab === 5 && (
                            <RefundsTab />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VendorDashBoard